<template>
  <div class="container">
    <div class="top-bg">
      <div class="navi">
          <router-link :to="orderURL">
            <span class="icon-arrow-left"></span>
          </router-link>
      </div>
      <div class="title" v-if="pay_status==0">定金支付</div>
      <div class="title" v-if="pay_status==2">订单支付</div>
    </div>
    <div class="weui-msg__text-area no-margin-bottom"  v-if="pay_status==0">
        <div class="notice-yellow">付款后客服将尽快向您致电确认订单</div>
    </div>
    <div class="weui-msg__text-area no-margin-bottom"  v-if="pay_status==2">
        <div class="notice-yellow">感谢使用我们的服务，请支付尾款</div>
    </div>
    <div class="prepay">
        <div class="payment">
          <div class="weui-cells weui-cells_checkbox payment-mg">

              <label class="weui-cell weui-check__label" for="s14" v-show="domainURL!=='portal-alipay.daojia.com.au'">
                  <div class="weui-cell__hd">
                      <input type="radio" name="checkbox1" v-model="pay_type" value="4" class="weui-check" id="s14" >
                      <i class="weui-icon-checked"></i>
                  </div>
                  <div class="weui-cell__bd">
                      <p class="valign cc-line">Visa / MasterCard 信用卡<img class="creditcard" src="../../assets/img/order/cc.svg"></p>
                  </div>
              </label>
<!-- 
              <label class="weui-cell weui-check__label" for="s1">
                  <div class="weui-cell__hd">
                      <input type="radio" name="checkbox1" v-model="pay_type" value="5" class="weui-check" id="s1" >
                      <i class="weui-icon-checked"></i>
                  </div>
                  <div class="weui-cell__bd">
                      <p class="valign cc-line">银联在线支付<span class="upop-notice">尾款优惠 $10</span><img class="creditcard" src="../../assets/img/order/upop.svg"></p>
                      <p class="valign cc-line">银联在线支付<img class="creditcard" src="../../assets/img/order/upop.svg"></p>
                  </div>
              </label>  -->
              <!-- <div class="upop-desc" v-show="pay_type==5">使用卡号62开头的银联借记卡或信用卡在线支付定金，可享受服务尾款立减 $10 优惠。<br><br>优惠先到先得，发完为止。</div> -->
              <!-- <label class="weui-cell weui-check__label" for="s11">
                  <div class="weui-cell__hd">
                      <input type="radio" class="weui-check" name="checkbox1" id="s11" v-model="pay_type" checked="checked" value="1">
                      <i class="weui-icon-checked"></i>
                  </div>
                  <div class="weui-cell__bd">
                      <p class="valign"><span class="politext">银行转账，支持多数澳洲银行</span> <img class="poli" src="../../assets/img/order/poli.png">  </p>
                  </div>
              </label> -->

<!--               <label class="weui-cell weui-check__label" for="s13">
                  <div class="weui-cell__hd">
                      <input type="radio" class="weui-check" name="checkbox1" id="s13" v-model="pay_type" checked="checked" value="3">
                      <i class="weui-icon-checked"></i>
                  </div>
                  <div class="weui-cell__bd">
                      <p class="valign"><span class="politext">PayPay</span> <img class="creditcard" src="../../assets/img/order/paypal.svg">  </p>
                  </div>
              </label> -->

              <label class="weui-cell weui-check__label" for="s12" v-if="notWechat">
                  <div class="weui-cell__hd">
                      <input type="radio" class="weui-check" name="checkbox1" id="s12" v-model="pay_type" checked="checked" value="2">
                      <i class="weui-icon-checked"></i>
                  </div>
                  <div class="weui-cell__bd">
                      <p class="valign"><span class="politext">支付宝</span> <img class="poli" src="../../assets/img/order/alipay.png">  </p>
                  </div>
              </label>
<!-- 
              <label class="weui-cell weui-check__label" for="x1">
                  <div class="weui-cell__hd">
                      <input type="radio" class="weui-check" name="checkbox1" id="x1" v-model="pay_type" checked="checked" value="x1">
                      <i class="weui-icon-checked"></i>
                  </div>
                  <div class="weui-cell__bd">
                      <p class="valign"><span class="politext">现金支付<span class="color-grey">（线下）</span></span> <img class="offline-pay" src="../../assets/img/order/pay-cash.svg">  </p>
                  </div>
              </label>
 -->

              <label class="weui-cell weui-check__label" for="s15">
                  <div class="weui-cell__hd">
                      <img class="ssl" src="../../assets/img/order/ssl.svg">
                  </div>
                  <div class="weui-cell__bd">
                      <p class="valign ssl-text">本站数据传输使用 SSL（安全套接字层）技术进行编码，保证支付数据与个人隐私安全</p>
                  </div>
              </label>
          </div>
        </div>

        <!-- <div class="weui-cells" v-if="orderDetail.insurance_amount>0 && orderDetail.pay_status==0">
            <div class="weui-cell weui-cell_access" @click="goto('/order-detail?id='+$route.query.id)">
                <div class="weui-cell__bd">
                    <p>订单号：</p>
                </div>
                <div class="weui-cell__ft">{{orderDetail.order_id}}</div>
            </div>
            <div class="weui-cell" >
                <div class="weui-cell__bd">
                    <p>定金：</p>
                </div>
                <div class="weui-cell__ft">{{parseFloat(priceAmount-this.orderDetail.insurance_amount)| numeral('$0,0.00')}}</div>
            </div>
            <div class="weui-cell" >
                <div class="weui-cell__bd">
                    <p>保险费：</p>
                </div>
                <div class="weui-cell__ft">{{parseFloat(this.orderDetail.insurance_amount) | numeral('$0,0.00')}}</div>
            </div>
            <div class="weui-cell" >
                <div class="weui-cell__bd">
                    <p class="color-orange">总金额</p>
                </div>
                <div class="weui-cell__ft color-orange">{{parseFloat(priceAmount)| numeral('$0,0.00')}}</div>
            </div>

        </div>-->

        <!-- <div class="weui-cells" v-else>-->
        <div class="weui-cells">
            <div class="weui-cell weui-cell_access" @click="goto('/order-detail?id='+$route.query.id)">
                <div class="weui-cell__bd">
                    <p>订单号：</p>
                </div>
                <div class="weui-cell__ft">{{orderDetail.order_id}}</div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__bd">
                    <p>待付金额：</p>
                </div>
                <div class="weui-cell__ft">{{parseFloat(priceAmount)| numeral('$0,0.00')}}</div>
            </div>
        </div>


        <div class="weui-msg__text-area text-center" v-if="pay_status==0">
            <p class="weui-msg__desc">定金可直接用于抵扣尾款费用。<br>
            支付前请阅读<router-link to="/refund-policy?back=1" class="color-orange">到家退款条例</router-link></span>，了解定金退款条件
            </p>
        </div>

        <div class="weui-msg__text-area text-center" v-if="pay_status==2">
          <p class="weui-msg__desc">
            支付前请阅读<router-link to="/refund-policy?back=1" class="color-orange">到家退款条例</router-link></span>，了解定金退款条件
          </p>
        </div>

        <div class="weui-msg__text-area text-center">
          <p class="weui-msg__desc office-address">
            Merchant Address：<br>
            Unit 7/175 James Ruse Drive <br>Rosehill, NSW 2142
          </p>
        </div>


        <div class="btn-box-fix">
          <div class="slogan" v-if="orderDetail.type_id=='1550735905'"><span class="icon-check-circle color-orange"></span> 点击立即支付表明您已阅读并同意<span class="color-orange">
              <span @click="$router.push('/move-terms?back=1');">到家搬家服务条款</span>
            </span>
          </div>
          <div class="slogan" v-else><span class="icon-check-circle color-orange"></span> 点击立即支付即表明您同意到家的服务条款</div>
          <div class="btn-container">
              <div class="btn active" @click="pay()" >立即支付 {{parseFloat(priceAmount)| numeral('$0,0.00')}}</div>
          </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在连接中</p>
            </div>
        </div>
    </transition>
    <transition name="fade">
      <v-modal v-if="showModal" @close="showModal = false">
        <div slot="body">
      
          <div class="modal-title">订单创建成功</div>

              <div class="info">我们已经收到您的订单<br><br>您的户型较为特别，我们的客服将尽快致电给您以了解情况并报价<br>您可以选择在接听电话后再支付定金</div>

              <div class="btn-box">
                <div class="btn active" @click="showModal = false" >好的</div>
              </div>
        </div>
      </v-modal>
    </transition>
    <img :src="orderPixelURL()" class="hide">
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'prepay',
  data () {
    return {
      isSending:false,
      pay_status:"",
      pay_type:4,
      showModal:false,
      priceAmount:0,
      orderDetail: {
        "error_code": 0,
        "data": {
          "type_id": "",
          "order_number": "",
          "order_id": "",
          "member_id": "",
          "member_name": "",
          "member_phone": "",
          "member_mail": "",
          "service_date": "",
          "service_time": "",
          "deposit_amount": "",
          "offers_amount": "",
          "other_amount": "",
          "payment_amount": "",
          "order_amount": "",
          "order_status": "",
          "pay_status": "",
          "prepaid_time": "",
          "pay_time": "",
          "created": "",
          "operates": null,
          "type_name": "",
          "order_status_name": "",
          "pay_status_name": "",
          "cost_data": {
                "type_id": "",
                "floor": "",
                "duplex_floor": "",
                "livingroom": "",
                "bedroom": "",
                "bathroom": "",
                "toiletroom": "",
                "garage": "",
                "is_return": "",
                "operates_num": ""
          },
          "details": {
                "house_type": "",
                "address": {
                    "address_name": "",
                    "address_phone": "",
                    "address_state": "",
                    "address_suburb": "",
                    "address_street": "",
                    "address_postcode": ""
                },
                "floor": "",
                "parking": "",
                "is_duplex": "",
                "duplex_floor": "",
                "labor_cost": "",
                "duplex_cost": "",
                "special_cost": "",
                "extra_cost": "",
                "extra_data": [],
                "service_start_time": "",
                "service_end_time": "",
                "service_pause_time": "",
                "service_pause_second": "",
                "service_period": "",
                "house_type_name": "",
                "floor_name": "",
                "parking_name": "",
                "attribute": {
                    "livingroom": "",
                    "bedroom": "",
                    "bathroom": "",
                    "toiletroom": "",
                    "study": "",
                    "balcony": "",
                    "garage": "",
                    "storage": "",
                    "swimming_pool": "",
                    "forecourt": "",
                    "backyard": ""
                }
          },
          "expiration_time": 0
        }
      },
    }
  },
  computed: {
    orderURL : function () {
      return "/order-detail?id="+ this.$route.query.id;
    }, 
    notWechat(){
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return false;
      } else {
          return true;
      }
    }
  },
  methods: {
    orderPixelURL(){
      let phone = "";
      if(localStorage.member_phone){
        phone = localStorage.member_phone;
      }
      return "https://log.daojia.com.au/pixel.log?phone="+phone+"&step=zhifu"
    },
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;

        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        //判断是正常订单，还是仓储子订单
        let apiString = '/Order/orderInfo';
        if(this.$route.query.subtype=='wp'){
          apiString = '/Order/getDeposit';
        }
        if(this.$route.query.subtype=='ws'){
          apiString = '/Order/storageInfo';
        }
        this.axios.post(this.apiURL()+ apiString, qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
            that.pay_status = that.orderDetail.pay_status;

            if(that.orderDetail.pay_status==0){
              that.priceAmount = that.orderDetail.payment_amount;
            }
            if(that.orderDetail.pay_status==2){
              that.priceAmount = that.orderDetail.payment_amount;
            }

            //刷新优惠券，领取新优惠券

            let couponObject={};
            couponObject.token = localStorage.token;
            couponObject.type_id = that.orderDetail.type_id;
            that.axios.post(that.apiURL()+'/Coupon/getCouponList', qs.stringify(couponObject))
            .then(function (response) {})
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并刷新页面")
            that.isSending=false;
        });
      }
    },
    pay(){
      if(this.pay_type==5){
        this.$router.push('/payment-upop?id='+this.$route.query.id+"&amount="+this.priceAmount);
        return false;
      }
      if(this.pay_type==4){
        window.location.href = '/stripe/cc.html?id='+this.$route.query.id+"&pay_status="+this.$route.query.status;
        return false;
      }
      if(this.pay_type=='x1'){
        this.$router.push('/order/pay-cash?id='+this.$route.query.id+"&amount="+this.priceAmount);
        return false;
      }
      if(this.isSending){
        return false;
      }
      else{
        let payObject={};
        let that = this;
        this.isSending = true;
        payObject.pay_type = this.pay_type;
        payObject.order_number = this.$route.query.id;
        if(this.$route.query.subtype=='ws'){
          payObject.jump_type = 1;
        }

        this.axios.post(this.apiURL()+'/Payment_Order/paymentAmount', qs.stringify(payObject))
        .then(function (response) {
          if(response.data.error_code==0){
            window.location.href=response.data.data;
          }
          else{
            console.log(response)
            alert("支付失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
            alert("支付失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
    if(this.$route.query.notify=="clean-rooms"){
      this.showModal = true;
    }
  },
  created: function () {
    if (this.domainURL == 'portal-alipay.daojia.com.au') {
        this.pay_type = 2;
    }
    if(this.$route.query.status){
      this.pay_status = this.$route.query.status;
    }
    this.getData();
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.navi{
  color:#fff;
}
.top-bg{
  background-image: url('/static/img/order/payment-bg.svg');
  background-repeat: no-repeat;
  width:100%;
  height:120px;
  background-position: center center;
  background-size: cover;
  position:absolute;
  top:0;
  padding-top:15px;
}

.title{
  color:#fff;
}

.modal-title{
	font-size:1.8em;
	font-weight:bold;
	text-align:center;
	color:#555;
}
.info{
	font-weight:100;
	text-align:center;
	padding-top:4px;
}
.description{
  text-align:center;
}

.order-detail{
  color:#fe9567;
  margin-top:24px;
}

.btn.white{
  margin-top:24px;
  width:170px;
  height:50px;
  font-size:1.1em;
}

.prepay{
  margin-top:10px;
}

.poli{
  width:50px;
  margin-left:10px;
}

.creditcard{
  width:70px;
  margin-left:10px;
}

.ssl{
  width:60px;
  margin:0 10px;
}


.valign{
  display: flex;
	justify-content:space-between;
	align-items:center
}
.ssl-text{
  font-size:0.7em;
  color:#888;
}
.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-msg{
    padding-top:20px;
    .weui-cells{
      text-align:left;
      font-size:0.9em;
      border-right:1px solid #eee;
      border-left:1px solid #eee;
      border-radius:5px;
    }
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
  .weui-msg__desc{
    margin:20px 0;
    font-size:15px;
    color:#777;
  }
  .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
    color:#fe9567;
  }

}

.upop-notice{
    text-align: center;
    background: #fff3cd;
    border: 1px solid #ffeeba;
    color: #856404;
    border-radius: 5px;
    padding: 2px 6px;
    font-size:0.8em;
    margin-left:-14px;
}

.no-margin-bottom{
  margin-bottom:0;
}

.notice-yellow{
  margin-top:136px;
}

.payment-mg{
  margin-top:12px;
}

.office-address{
  font-size:11px;
  margin-bottom:80px!important;
}

.offline-pay{
  width:30px;
}

.slogan{
  margin-top:6px;
  margin-bottom:-5px;
  font-size:0.8em;
  color:#777;
}

.upop-desc{
  padding:0 22px 10px 22px;
  font-size:0.8em;
  color:#888;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-prepay.vue